function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiAccordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
// Limitless imports
import Typography from "../../data-display/typography/Typography";
import PlusIcon from "@limitless/icons/Plus";
import LineIcon from "@limitless/icons/Line";
import Divider from "../../data-display/divider/Divider";
import Grid from "../../layout/Grid";
const CustomAccordion = styled(MuiAccordion)(() => ({
  boxShadow: "none !important",
  borderRadius: "0px !important",
  maxWidth: "100% !important",
  backgroundColor: "transparent",
  backgroundImage: "none",
  "&:before": {
    backgroundColor: "transparent !important"
  }
}));
const CustomAccordionSummary = styled(AccordionSummary)(() => ({
  padding: "33.5px 0px 25.5px 0px",
  maxWidth: "100% !important",
  "& .MuiAccordionSummary-content": {
    marginTop: 0
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(0deg) !important"
  }
}));
const CustomAccordionDetails = styled(AccordionDetails)(() => ({
  padding: 0
}));
const Icon = styled(props => /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(PlusIcon, {
  className: "plus",
  sx: {
    color: theme => theme.palette.primary.light
  }
}), /*#__PURE__*/React.createElement(LineIcon, {
  className: "line",
  sx: {
    color: theme => theme.palette.primary.light
  }
})))`
    & > .plus {
        display: block;
        margin-top: -4px;
    }
    & > .line {
        display: none;
    }
    .Mui-expanded & > .line {
        display: block;
        margin-top: 10px;
    }
    .Mui-expanded & > .plus {
        display: none;
    }
`;
const Accordion = ({
  id = "accordion-default-id",
  title,
  description,
  expanded,
  children,
  showDivider = false,
  loading = false,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomAccordion, _extends({
    expanded: expanded
  }, rest, {
    id: id,
    disableGutters: true
  }), /*#__PURE__*/React.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(Grid, {
      position: "relative",
      display: "inline-flex",
      backgroundColor: true
    }, loading && !expanded && /*#__PURE__*/React.createElement(Grid, {
      position: "absolute"
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      size: 30,
      sx: {
        marginTop: -1.4,
        marginLeft: -0.8,
        color: theme => theme.palette.primary.light
      }
    })), /*#__PURE__*/React.createElement(Icon, null)),
    "aria-controls": `${id}-accorrdion-summary-content`
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    sx: {
      color: theme => theme.palette.grey[4]
    }
  }, title)), /*#__PURE__*/React.createElement(CustomAccordionDetails, null, description && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      color: theme => theme.palette.grey[4]
    }
  }, description), children)), showDivider && /*#__PURE__*/React.createElement(Divider, null));
};
Accordion.propTypes = {
  id: PropTypes.string,
  expanded: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showDivider: PropTypes.bool,
  loading: PropTypes.bool
};
export default Accordion;